module.exports = __webpack_public_path__ + "static/Wilcox-877267ed02507e0ce250283c96a9e66d.jpg";